import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const ExperienceItem = ({ number, title, description, meta, showArrow = false, descriptionClassName }) => (
  <div className="experience-item">
    <div className="experience-number">{number}</div>
    <h3 className="experience-title">
      {title}
      {showArrow && <ArrowUpRight size={14} className="inline-arrow" />}
    </h3>
    <p className={`experience-description ${descriptionClassName || ''}`.trim()}>
      {description}
    </p>
    {meta && <p className="experience-meta">{meta}</p>}
  </div>
);

export default ExperienceItem;
